"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Trip2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Trip"));
var _RegionalSettingsButton = _interopRequireDefault(require("../components/RegionalSettingsButton"));
var _Media = _interopRequireDefault(require("../components/Media"));
var _context = require("../services/context");
var _events = require("../consts/events");
var _context2 = require("../../../services/log/context");
var _jsxRuntime = require("react/jsx-runtime");
var _Trip, _FormattedMessage;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NavRightLinks = _ref => {
  let {
    modalId,
    brandLanguage,
    onOpenHelp
  } = _ref;
  const {
    isRegionalSettingsShown,
    isHelpShown
  } = (0, _context.useNavConfig)();
  const intl = (0, _reactIntl.useIntl)();
  const {
    log
  } = (0, _context2.useLog)();
  const handleHelpButtonClick = () => {
    onOpenHelp();
    log(_events.HELP_BUTTON_CLICKED, {});
  };
  const regionalSettingsRef = React.useRef(null);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
    inline: true,
    align: "center",
    justify: "end",
    spacing: "none",
    largeMobile: {
      spacing: "400"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Media.default, {
      greaterThanOrEqual: "tablet",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        inline: true,
        align: "center",
        justify: "end",
        spacing: "600",
        children: [isRegionalSettingsShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RegionalSettingsButton.default, {
          triggerRef: regionalSettingsRef,
          modalId: modalId,
          brandLanguage: brandLanguage,
          simple: true,
          render: _ref2 => {
            let {
              text,
              openModal
            } = _ref2;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
              compact: true,
              dataTest: "TopNav-RegionalSettingsButton",
              iconLeft: _Trip || (_Trip = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Trip2.default, {
                size: "small",
                ariaHidden: true
              })),
              rel: "nofollow",
              title: intl.formatMessage({
                id: "navbar.header.regional_settings_switcher"
              }),
              type: "secondary",
              onClick: openModal,
              ref: regionalSettingsRef,
              children: text
            });
          }
        }), isHelpShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
          compact: true,
          type: "secondary",
          dataTest: "TopNav-HelpButton",
          onClick: handleHelpButtonClick,
          children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "navbar.header.help_and_support"
          }))
        })]
      })
    })
  });
};
var _default = exports.default = NavRightLinks;